<template>
  <div class="messagesBox" v-if="show">
    <div  class="messages">
      <i class="el-icon-circle-check"></i>
      <span>{{tips}}</span>
    </div>
  </div>
</template>

<script>

export default {
  props:["tips"],
  data(){
    return{
      show:false,
      timer:null
    }
  },
  beforeDestroy(){
    clearInterval(this.timer);
  },
  watch:{
    show:{
      handler(newVal,oldVal){
        if(newVal){
          let n = 2;
          this.timer = setInterval(() => {
            n--;
            if(n<=0){
              clearInterval(this.timer);
              n==0;
              this.show =false;
            }
          }, 1000);
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .messagesBox{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left:0;
    z-index: 9;
    .messages{
      width: 300px;
      height: 80px;
      background-color: rgba(0, 0, 0, 0.75);
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 80px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -40px;
      margin-left: -150px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Messages.vue